import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { ProductAttributesAdminState } from "../../models/mp-admin/product-attributes-state";

const initialState: ProductAttributesAdminState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(AdminProductsActions.productAttributes.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(AdminProductsActions.productAttributes.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		...action.state,
		loading: false
	})),
	on(AdminProductsActions.productAttributes.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(AdminProductsActions.productAttributes.invalidate, () => initialState)
);

export function productAttributesAdminReducer(
	state: ProductAttributesAdminState | undefined,
	action: Action
): ProductAttributesAdminState {
	return reducer(state, action);
}
